export const SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTIONS_REQUEST';
export const SUBSCRIPTIONS_SUCCESS = 'SUBSCRIPTIONS_SUCCESS';
export const SUBSCRIPTIONS_FAILURE = 'SUBSCRIPTIONS_FAILURE';

export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS';
export const SUBSCRIPTION_FAILURE = 'SUBSCRIPTION_FAILURE';

export const SUBSCRIPTION_CANCEL_REQUEST = 'SUBSCRIPTION_CANCEL_REQUEST';
export const SUBSCRIPTION_CANCEL_SUCCESS = 'SUBSCRIPTION_CANCEL_SUCCESS';
export const SUBSCRIPTION_CANCEL_FAILURE = 'SUBSCRIPTION_CANCEL_FAILURE';

export const UPDATE_SUBSCRIPTIONS = 'UPDATE_SUBSCRIPTIONS';

export const QUIT_SHARING_SUCCESS = 'QUIT_SHARING_SUCCESS';

export const GET_SUBSCRIPTION_DELIVERY_REQUEST = 'GET_SUBSCRIPTION_DELIVERY_REQUEST';
export const GET_SUBSCRIPTION_DELIVERY_SUCCESS = 'GET_SUBSCRIPTION_DELIVERY_SUCCESS';
export const GET_SUBSCRIPTION_DELIVERY_FAILURE = 'GET_SUBSCRIPTION_DELIVERY_FAILURE';
